<template>
    <div class="study">
        <studySearch @searchClick='searchClick'  :sourceType="'study'"></studySearch>
        <div class="study-cont"> 
            <el-tabs v-model="tabName" type="card" @tab-click="tab_click">
                <el-tab-pane v-for="(item,index) in tabNav" :key="index" :label="`${item.val}(${item.num})`" :name="item.type"></el-tab-pane> 
            </el-tabs>
            <div class="study-info">
                <bookList ref='bookList' v-show='tabName=="1"' ></bookList>
                <articleList ref='articleList' v-show='tabName=="2"' ></articleList>
            </div>
        </div>
    </div>
</template>

<script>
import studySearch from './comps/study_search.vue';
import bookList from './comps/book.vue';
import articleList from './comps/article.vue'; 
import {mapState,mapMutations } from 'vuex';
export default {
    components: {
        studySearch, 
        bookList,
        articleList
    },
    data () {
        return { 
            searchWord:this.$route.query.searchWord||'',
            tabName:'1', 
        }
    },
    computed: {
        ...mapState({
            searchVal: state => state.study.searchVal,
            tabNav: state => state.study.tabNav,
             
        }),
    },
    methods: {
        ...mapMutations(['setSearchVal','setLeftNavIndex']),
        tab_click(tab,e){   
            this.tabName=tab.name; 
            this.setLeftNavIndex('');
            // 切换时刷新对应的左侧列表和内容列表
            this.$nextTick(() => {
                if(this.tabName == '1'){
                    this.$refs.bookList.init();
                } else if(this.tabName == '2'){
                    this.$refs.articleList.init();
                }
            });
        },
        searchClick(){
            console.log(this.searchVal,'searchClick');
            this.$refs.bookList.init('refresh'); 
            this.$refs.articleList.init('refresh'); 
        }, 
        advancedSearch(){
            
        },
         
    }
}
</script>

<style lang="less" scoped>
    @import url('./study.less');
    .study{
        min-width: 1200px;
        margin-bottom: 40px;
        // background: linear-gradient( 180deg, rgba(229,244,255,0) 0%, rgba(229,243,255,0.94) 40%, #E5F3FF 100%);
        
        .study-cont{
            width: 1200px;
            margin: 0 auto;
            ::v-deep .el-tabs__item{
                font-size: 16px;
                padding:0 40px
                 
            }
            ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active{
                background: #F1F5FE;
                // background: #386DE8;
                color: #386DE8;
            }
        }
    }
    
</style>